import React from 'react';
import PropTypes from 'prop-types';

import {
    useCurationConfigState
} from '../../../hooks/widgetConfiguration.js';

import RIQDropdown from '../../../components/RIQDropdown.jsx';


DriverTypeSelector.propTypes = {
    instanceId: PropTypes.string.isRequired
};


export default function DriverTypeSelector({instanceId}) {
    const [driver, setDriver] = useCurationConfigState(instanceId, 'driver');

    const intervalOptions = [
        {
            id: 'attributes',
            name: 'Attributes'
        }, {
            id: 'behaviors',
            name: 'Behaviors'
        }, {
            id: 'emotions',
            name: 'Emotions'
        }
    ];
    const selectedDriver = _.find(intervalOptions, {
        id: driver
    }) || _.head(intervalOptions);
    selectedDriver.selected = true;

    return (
        <div>
            <span className='tlw-text-sm'>Type:&nbsp;</span>
            <RIQDropdown
                variant='small'
                title={selectedDriver.name}
                dropdownOptions={intervalOptions}
                onItemSelected={(selectedOption) => setDriver(selectedOption.id)}
            />
        </div>
    );
}
